var _defs, _defs2, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeCanary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 9390 9390",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 5435,
    x2: 2552,
    y1: 8086,
    y2: 6397,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#bf360c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 1459,
    x2: 4233,
    y1: 3632,
    y2: 2011,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#bf360c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 5816,
    x2: 2652,
    y1: 8314,
    y2: 6458,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#bf360c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 5978,
    x2: 6704,
    y1: 2417,
    y2: 5596,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ea6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 5979,
    x2: 6691,
    y1: 2430,
    y2: 5541,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#bf360c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 1405,
    x2: 4000,
    y1: 3663,
    y2: 2147,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#a52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 350,
    x2: 6413,
    y1: 5107,
    y2: 5107,
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2a700",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f19800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 1293.44,
    cy: 56.19,
    r: 166.25,
    gradientTransform: "matrix(25 0 0 -25 -27825 4125)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf360c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 1154.43,
    cy: 70.88,
    r: 154.31,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 1300.69,
    cy: -23.27,
    r: 173.74,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 602.97,
    cy: 103.52,
    r: 349.48,
    gradientTransform: "matrix(25 0 0 -25 -13425 4125)",
    xlinkHref: "#a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350 4700a4350 4350 0 118700 0 4350 4350 0 11-8700 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2988 5690l1712-2967h4350V350H1040v1994"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M4700 2723l1713 2967-1923 3360h4560V2723H4700z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M350 9050h4140l1922-1922V5690H2988L350 1165v7885z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M1040 350v5340h1947l1713-2967h4350V350H1040z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "g",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    id: "l",
    xlinkHref: "#d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#f09300",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#i)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bf360c",
    fillOpacity: 0.15,
    d: "M3035 5670L1066 2295l-30 50 1955 3352 43-25z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#f4b400",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#j)",
    xlinkHref: "#g"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a52714",
    fillOpacity: 0.15,
    d: "M6373 5754l-40-23-1898 3320h57l1882-3296z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#ffcd40",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#m)",
    xlinkHref: "#l"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#f7cb4d",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#n)",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f09300",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#p)",
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M4700 2723v1035l3875-1035H4700z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#r)",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M1040 2350l2830 2830-882 510-1948-3340z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M4494 9045l1036-3865 883 510-1920 3356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M2723 4700a1977 1977 0 113954 0 1977 1977 0 01-3954 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6bf26",
    d: "M3118 4700a1580 1580 0 113164 0 1580 1580 0 11-3164 0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bf360c"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M4700 2673a1977 1977 0 00-1977 1978v50a1977 1977 0 011977-1978h4350v-50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4750 2723h-25a1976 1976 0 010 3952h25a1977 1977 0 000-3955z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.15,
    d: "M4700 9000a4350 4350 0 004350-4325v25a4350 4350 0 11-8700 0v-25a4350 4350 0 004350 4325z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    d: "M6410 5690a1974 1974 0 01-3421 0L350 1215l2638 4525a1974 1974 0 003421 0v-50z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M6430 5754a1971 1971 0 00170-1584 1955 1955 0 01-191 1517L4490 9050h57l1883-3294zM4700 400a4350 4350 0 014350 4325v-25a4350 4350 0 10-8700 0v25A4350 4350 0 014700 400z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M350 4700a4350 4350 0 118700 0 4350 4350 0 11-8700 0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeCanary);
export default __webpack_public_path__ + "static/media/chrome-canary.aae63649dc5ebd37d013c2fd2d03e85a.svg";
export { ForwardRef as ReactComponent };